var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "bookings.show", params: { id: _vm.booking.id } },
    },
    scopedSlots: _vm._u(
      [
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  _vm.booking.local_currency
                    ? [
                        _vm._v(
                          "\n      " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.booking.local_budget_per_star,
                                _vm.booking.local_currency
                              )
                            ) +
                            "\n    "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n      " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.booking.budget_per_star,
                                _vm.booking.currency
                              )
                            ) +
                            "\n    "
                        ),
                      ],
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }